/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_DurationInputs */

const en_us2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest time in a set`)
};

const pt_br2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior tempo numa série`)
};

const es_419_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor tiempo en una serie`)
};

const pt_pt2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior tempo numa série`)
};

const fr_fr2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus longue durée en une série`)
};

const de_de2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längste Zeit in einem Satz`)
};

const it_it2_workout_live_record_duration = /** @type {(inputs: Workout_Live_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo più lungo in una serie`)
};

/**
* | output |
* | --- |
* | "Longest time in a set" |
*
* @param {Workout_Live_Record_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_duration = /** @type {((inputs?: Workout_Live_Record_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_duration(inputs)
	if (locale === "es-419") return es_419_workout_live_record_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_duration(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_duration(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_duration(inputs)
	return en_us2_workout_live_record_duration(inputs)
});
export { workout_live_record_duration as "workout-live.record_duration" }